
import React, { useState, useEffect } from "react";
import "./FlashCard.css";

export default function FlashCard({ card, autoMode, triggerFlip, animateKey, isMuted }) {
  const [flipped, setFlipped] = useState(false);
  const [fadeClass, setFadeClass] = useState("");
  const [hideText, setHideText] = useState(false);

  useEffect(() => {
    setHideText(true); // hide text right away before fade
    setFadeClass("fade-out");
    const t = setTimeout(() => {
      setFadeClass("");
      setHideText(false); // restore text after fade
    }, 150);
    return () => clearTimeout(t);
  }, [animateKey]);

  useEffect(() => {
    setFlipped(false);
  }, [card?.id]);

  useEffect(() => {
    if (autoMode && triggerFlip) {
      const t = setTimeout(() => setFlipped(true), 100);
      return () => clearTimeout(t);
    }
  }, [triggerFlip, autoMode]);

  const handleClick = () => {
    if (!flipped) {
      setFlipped(true);
      if (card?.type === "audioText" && !isMuted) {
        const audio = new Audio(`/audio/${card.answerAudio}`);
        audio.play();
      }
    }
  };

  const frontContent = !hideText ? (
    card?.type?.includes("flip") || card?.type === "imageFlip"
      ? <img src={card.img || card.image} alt="card front" className="flashcard-img" />
      : <div className="flashcard-text">{card.text?.question}</div>
  ) : null;

  const backContent = !hideText ? (
    card?.type?.includes("flip") || card?.type === "imageFlip"
      ? <div className="flashcard-text">{card.label || card.back}</div>
      : <div className="flashcard-text">{card.text?.answer}</div>
  ) : null;

  return (
    <div className={`flashcard-wrapper ${fadeClass}`}>
      <div className={`flashcard ${flipped ? "flipped" : ""}`} onClick={handleClick}>
        <div className="flashcard-inner">
          <div className="flashcard-front">{frontContent}</div>
          <div className="flashcard-back">{backContent}</div>
        </div>
      </div>
    </div>
  );
}
